import { render, staticRenderFns } from "./BackOfficeList.vue?vue&type=template&id=301ad064&scoped=true&"
import script from "./BackOfficeList.vue?vue&type=script&lang=js&"
export * from "./BackOfficeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301ad064",
  null
  
)

export default component.exports